import axios from "axios";

const urlPath = "categoriaKae";

export const getCategoriasKae = async () => {
  try {
    const response = await axios.get(urlPath);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getCategoriaKae = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const createCategoriaKae = async (data) => {
  try {
    const response = await axios.post(urlPath, {
      nombre: data.nombre,
      descripcion: data.descripcion,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const updateCategoriaKae = async (id, data) => {
  try {
    const response = await axios.put(`${urlPath}/${id}`, {
      nombre: data.nombre,
      descripcion: data.descripcion,
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const deleteCategoriaKae = async (id) => {
  try {
    const response = await axios.delete(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
